// ATW-7285 Reinstate below linting rule once timetable recent search is reinstated
/* eslint no-unused-vars: 0 */

import { call, put, takeLatest } from 'redux-saga/effects';
import timetablesActionCreators, { TimetableTypes } from '../redux/TimetablesRedux';
import liveDepartureActionCreators from '../redux/LiveDeparture';
import routeAutosuggestActionCreators, { RouteAutosuggestTypes } from '../redux/RouteAutosuggestRedux';
import {
  getStopsByShapeId,
  getTimetableRoutes,
  getTimetableSchedule, saveRouteSearch,
  getRecentRouteSearches,
} from '../services/TimetablesService';

export function* queryTimetableSchedule({
  routeShortName, stopCode, selectedRoute, searchMode,
}) {
  const { shape_ids: shapeId } = selectedRoute;

  try {
    const timetable = yield call(getTimetableSchedule, { shapeId, stopCode, routeShortName });
    yield put(timetablesActionCreators(searchMode).selectStopSuccess(timetable));
  } catch (e) {
    yield put(timetablesActionCreators(searchMode).selectStopError(e.message));
  }
}

export function* queryTimetableStops({ route, searchMode }) {
  try {
    const shapeIds = route.shape_ids;
    const stopsResponse = yield call(getStopsByShapeId, { shapeIds });
    const transformedStops = stopsResponse.map((stop, index) => ({ ...stop, key: index }));
    yield put(timetablesActionCreators(searchMode).retrieveStopsSuccess(transformedStops));
  } catch (e) {
    yield put(timetablesActionCreators(searchMode).retrieveStopsError(e.message));
  }
}

export function* gotoLiveDepartureRequest({ selectedStop, history }) {
  yield history.push('/live-departures');
  const address = `${selectedStop.stop_code} - ${selectedStop.stop_name}`;
  yield put(liveDepartureActionCreators.setText(address));
  yield put(liveDepartureActionCreators.selectAddress({
    category: 'BUSSTOP',
    address,
  }));
}

export function* fetchRecentSearches({ query, searchMode, baseStorageKey }) {
  const storageKey = `${baseStorageKey}-${searchMode}`;
  const results = (yield call(getRecentRouteSearches, storageKey, query)) || [];
  yield put(routeAutosuggestActionCreators(searchMode).fetchRecentSearchesSuccess(results));
}

export function* fetchSuggestions({ query, searchMode }) {
  try {
    const results = (yield call(getTimetableRoutes, { text: query.trim(), searchMode })) || [];
    yield put(routeAutosuggestActionCreators(searchMode).fetchSuggestionsSuccess(query, results));
  } catch (e) {
    yield put(routeAutosuggestActionCreators(searchMode).fetchSuggestionsError(e.message));
  }
}

export function* selectSuggestion({ selected, searchMode, baseStorageKey }) {
  /*
  ATW-7285 Disabling recent search temporarily. Once issues are resolved it will be reinstated.*
 const storageKey = `${baseStorageKey}-${searchMode}`;.
  yield call(saveRouteSearch, selected, storageKey);
  */
  yield put(timetablesActionCreators(searchMode).retrieveStopsRequest((selected.routes || [])[0]));
}

export default function root() {
  return [
    takeLatest(RouteAutosuggestTypes.FETCH_RECENT_SEARCHES, fetchRecentSearches),
    takeLatest(RouteAutosuggestTypes.FETCH_SUGGESTIONS, fetchSuggestions),
    takeLatest(RouteAutosuggestTypes.SELECT_SUGGESTION, selectSuggestion),
    takeLatest(TimetableTypes.RETRIEVE_STOPS_REQUEST, queryTimetableStops),
    takeLatest(TimetableTypes.SELECT_STOP_REQUEST, queryTimetableSchedule),
    takeLatest(TimetableTypes.GOTO_LIVE_DEPARTURE_REQUEST, gotoLiveDepartureRequest),
  ];
}
